import { PRODUCT_TYPE_NAME_BY_ID } from '../../../../consts'
import { BatchAliasAssignment } from '../../../../redux/types/productAliases'
import { BatchLookupValue } from '../../../../redux/types/ui'
import { ProductType } from '../../../../types'

type YesType = 'yes' | ''

export interface BatchLookupCsvRow {
  store: string
  name: string
  alias: string
  product_type: Capitalize<ProductType> | ''
  needs_tlc: YesType
  fix_category: YesType
  no_match: YesType
  ignored: YesType
  assignee_id: string
  assignee_name: string
  assignee_url: string
}

interface BatchAliasAssignmentCsvRow
  extends Omit<Partial<BatchAliasAssignment>, 'batchSelectedProduct'> {
  batchSelectedProduct?: { attributes: any; id: number }
}

interface BatchAliasAssignmentsCSV {
  [key: string]: BatchAliasAssignmentCsvRow
}

const booleanToString = (value?: boolean): YesType => (value ? 'yes' : '')

export const batchLookupToCsvRows = (
  batchLookupValues: Pick<BatchLookupValue, 'productType' | 'store' | 'name' | 'alias'>[],
  batchAliasAssignments: BatchAliasAssignmentsCSV
): BatchLookupCsvRow[] => {
  return batchLookupValues.map((lookupValue, index) => {
    const batchAliasAssignment = batchAliasAssignments[index] || {}
    const { isConfirmed, workstreamTags, isIgnored, batchSelectedProduct } = batchAliasAssignment
    const hasProduct = isConfirmed && batchSelectedProduct

    const product_type = lookupValue.productType
      ? (PRODUCT_TYPE_NAME_BY_ID[parseInt(lookupValue.productType)] as Capitalize<ProductType>)
      : ''

    return {
      store: lookupValue.store,
      name: lookupValue.name,
      alias: lookupValue.alias,
      product_type,
      ignored: booleanToString(isIgnored),
      needs_tlc: booleanToString(workstreamTags?.needsTlc),
      fix_category: booleanToString(workstreamTags?.fixCategory),
      no_match: booleanToString(workstreamTags?.noMatch),
      assignee_id: hasProduct ? batchSelectedProduct.id.toString() : '',
      assignee_name: hasProduct ? batchSelectedProduct.attributes.name : '',
      assignee_url: hasProduct ? batchSelectedProduct.attributes.url : '',
    }
  })
}
